import EmblaCarousel, { type EmblaCarouselType } from 'embla-carousel'

/**
 * Carrossel do banner principal. Só é inicializado quando há mais de um slide
 * (o PHP omite o atributo `data-hero` no caso de banner único).
 */

function buildDots(embla: EmblaCarouselType, dotsNode: HTMLElement): void {
  const render = (): void => {
    dotsNode.innerHTML = embla
      .scrollSnapList()
      .map(
        (_, i) =>
          `<button type="button" role="tab" aria-selected="false" aria-label="Banner ${i + 1}"></button>`,
      )
      .join('')

    dotsNode.querySelectorAll('button').forEach((dot, i) => {
      dot.addEventListener('click', () => embla.scrollTo(i))
    })
  }

  const sync = (): void => {
    const selected = embla.selectedScrollSnap()
    dotsNode.querySelectorAll('button').forEach((dot, i) => {
      dot.setAttribute('aria-selected', String(i === selected))
    })
  }

  embla.on('init', render).on('reInit', render)
  embla.on('init', sync).on('reInit', sync).on('select', sync)
}

function initHero(): void {
  const root = document.querySelector<HTMLElement>('[data-hero]')
  if (!root) return

  const viewport = root.querySelector<HTMLElement>('[data-hero-viewport]')
  if (!viewport) return

  const embla = EmblaCarousel(viewport, { loop: true, align: 'start' })

  const dots = root.querySelector<HTMLElement>('[data-hero-dots]')
  if (dots) buildDots(embla, dots)

  const delay = Number(root.dataset.heroAutoplay ?? 0)
  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches

  if (delay > 0 && !reduced) {
    let timer = window.setInterval(() => embla.scrollNext(), delay)

    const stop = (): void => window.clearInterval(timer)
    const start = (): void => {
      stop()
      timer = window.setInterval(() => embla.scrollNext(), delay)
    }

    root.addEventListener('mouseenter', stop)
    root.addEventListener('mouseleave', start)
    root.addEventListener('focusin', stop)
    embla.on('pointerDown', stop).on('pointerUp', start)
    document.addEventListener('visibilitychange', () =>
      document.hidden ? stop() : start(),
    )
  }
}

document.addEventListener('DOMContentLoaded', initHero)
